import styled, { DefaultTheme, css } from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  position: relative;
  z-index: 0;
  gap: 8px;
`;

type ItemTypes = {
  selected: boolean;
  range: boolean;
};

const ItemModifiers = {
  selected: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.neutralSilver50};
    color: ${theme.colors.globalWhite100};
    font-weight: 500;
  `,
  range: (theme: DefaultTheme, selected: boolean) => css`
    background-color: ${!selected && theme.colors.neutralGray10};
    border-radius: ${!selected && 0};
    color: ${!selected && theme.colors.neutralSilver60};
    height: 22px;
    align-self: center;

    &.selected {
      &::after {
        content: '';
      }

      &::before {
        content: none;
      }
    }

    + .selected {
      &::after {
        content: none;
      }

      &::before {
        content: '';
      }
    }

    &.selected + div:not(.selected) {
      &::before {
        content: none;
      }
    }

    &::before {
      content: '';
      position: absolute;
      height: 22px;
      width: 20px;
      background-color: ${theme.colors.neutralGray10};
      left: -10px;
      z-index: -1;
    }

    &::after {
      content: '';
      position: absolute;
      height: 22px;
      width: 20px;
      background-color: ${theme.colors.neutralGray10};
      right: -10px;
      z-index: -1;
    }
  `,
};

export const Item = styled.div<ItemTypes>`
  ${({ theme, selected, range }) => css`
    min-width: 24px;
    height: 24px;
    padding: 2px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: ${theme.colors.neutralSilver70};
    position: relative;

    ${selected && ItemModifiers.selected(theme)}
    ${range && ItemModifiers.range(theme, selected)}
  `}
`;
